import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_6ee0d2b0 from 'nuxt_plugin_sentryserver_6ee0d2b0' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_62d62520 from 'nuxt_plugin_sentryclient_62d62520' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_nuxtizitoastplugin6b8174d6_50fee7c0 from 'nuxt_plugin_nuxtizitoastplugin6b8174d6_50fee7c0' // Source: ./nuxt-izitoast.plugin.6b8174d6.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_1fd4528c from 'nuxt_plugin_cookieuniversalnuxt_1fd4528c' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_0e760a38 from 'nuxt_plugin_axios_0e760a38' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_377bd052 from 'nuxt_plugin_pluginutils_377bd052' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_dbc7e93c from 'nuxt_plugin_pluginrouting_dbc7e93c' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_798d6b4d from 'nuxt_plugin_pluginmain_798d6b4d' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_workbox_5d424700 from 'nuxt_plugin_workbox_5d424700' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_9136e3da from 'nuxt_plugin_metaplugin_9136e3da' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_87e798f2 from 'nuxt_plugin_iconplugin_87e798f2' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_lazySizes_0d8f1b5c from 'nuxt_plugin_lazySizes_0d8f1b5c' // Source: ./lazySizes.js (mode: 'all')
import nuxt_plugin_routes_3e5c7b80 from 'nuxt_plugin_routes_3e5c7b80' // Source: ../plugins/routes (mode: 'all')
import nuxt_plugin_loadstore_3c99cd30 from 'nuxt_plugin_loadstore_3c99cd30' // Source: ../plugins/load-store (mode: 'all')
import nuxt_plugin_logger_630bf334 from 'nuxt_plugin_logger_630bf334' // Source: ../../../node_modules/@ostadbank-front/plugins/logger (mode: 'all')
import nuxt_plugin_api_eb49b6c8 from 'nuxt_plugin_api_eb49b6c8' // Source: ../../../node_modules/@ostadbank-front/plugins/service/api (mode: 'all')
import nuxt_plugin_axios_469b2f02 from 'nuxt_plugin_axios_469b2f02' // Source: ../../../node_modules/@ostadbank-front/plugins/service/axios.js (mode: 'all')
import nuxt_plugin_multiselect_628eaff4 from 'nuxt_plugin_multiselect_628eaff4' // Source: ../../../node_modules/@ostadbank-front/plugins/multiselect.js (mode: 'all')
import nuxt_plugin_gtag_03b3abc0 from 'nuxt_plugin_gtag_03b3abc0' // Source: ../../../node_modules/@ostadbank-front/plugins/gtag.js (mode: 'all')
import nuxt_plugin_savelatestroute_165ae8e8 from 'nuxt_plugin_savelatestroute_165ae8e8' // Source: ../../../node_modules/@ostadbank-front/plugins/save-latest-route.js (mode: 'all')
import nuxt_plugin_globaldirectives_4a6f1926 from 'nuxt_plugin_globaldirectives_4a6f1926' // Source: ../../../node_modules/@ostadbank-front/plugins/global-directives.js (mode: 'all')
import nuxt_plugin_vueshortkey_3b659fc9 from 'nuxt_plugin_vueshortkey_3b659fc9' // Source: ../../../node_modules/@ostadbank-front/plugins/vue-shortkey.js (mode: 'client')
import nuxt_plugin_globalcomponents_54a1811b from 'nuxt_plugin_globalcomponents_54a1811b' // Source: ../../../node_modules/@ostadbank-front/plugins/global-components.js (mode: 'all')
import nuxt_plugin_vueawesomeswiper_c02e0a2c from 'nuxt_plugin_vueawesomeswiper_c02e0a2c' // Source: ../../../node_modules/@ostadbank-front/plugins/vue-awesome-swiper.js (mode: 'all')
import nuxt_plugin_leafletclient_48531b77 from 'nuxt_plugin_leafletclient_48531b77' // Source: ../../../node_modules/@ostadbank-front/plugins/leaflet.client.js (mode: 'client')
import nuxt_plugin_auth_e03c7c68 from 'nuxt_plugin_auth_e03c7c68' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_78fc5baa from 'nuxt_plugin_auth_78fc5baa' // Source: ../../../node_modules/@ostadbank-front/plugins/auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"__dangerouslyDisableSanitizers":["script"],"title":"تدریس خصوصی و معلم خصوصی | در منزل و آنلاین | استادبانک","htmlAttrs":{"dir":"rtl","lang":"fa"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=0, viewport-fit=cover"},{"name":"mobile-web-app-capable","content":"yes"},{"hid":"description","name":"description","content":"استادبانک سامانه‌ای معتبر و محبوب برای ارتباط بهترین معلم‌های خصوصی به دانش‌آموزان است. ما در بیش از 970 درس، بهترین معلم‌های خصوصی را داریم🥇"},{"name":"ROBOTS","content":"index,follow"},{"hid":"twitter:account_id","name":"twitter:account_id","content":"3032584237"},{"hid":"twitter:card","name":"twitter:card","content":"summary"},{"hid":"twitter:url","name":"twitter:url","content":"https:\u002F\u002Fwww.ostadbank.com"},{"hid":"twitter:title","name":"twitter:title","content":"تدریس خصوصی و معلم خصوصی | آنلاین و حضوری | استادبانک"},{"hid":"twitter:site","name":"twitter:site","content":"@ostadbank"},{"hid":"twitter:description","name":"twitter:description","content":"استادبانک سامانه‌ای معتبر و محبوب برای ارتباط بهترین معلم‌های خصوصی به دانش‌آموزان است. ما در بیش از 970 درس، بهترین معلم‌های خصوصی را داریم🥇"},{"hid":"twitter:images","name":"twitter:images","content":"https:\u002F\u002Fwww.ostadbank.com\u002Fbuild\u002Fimages\u002Fsocial-network-logo.jpg"},{"hid":"og:local","property":"og:local","content":"fa_IR"},{"hid":"og:site_name","property":"og:site_name","content":"Ostadbank.com"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:title","property":"og:title","content":"تدریس خصوصی و معلم خصوصی | آنلاین و حضوری | استادبانک"},{"hid":"og:description","property":"og:description","content":"استادبانک سامانه‌ای معتبر و محبوب برای ارتباط بهترین معلم‌های خصوصی به دانش‌آموزان است. ما در بیش از 970 درس، بهترین معلم‌های خصوصی را داریم🥇"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fwww.ostadbank.com"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fwww.ostadbank.com\u002Fbuild\u002Fimages\u002Fsocial-network-logo.jpg"},{"hid":"og:image:alt","property":"og:image:alt","content":"ostadbank-logo"}],"link":[{"hid":"image","rel":"preload","as":"image","media":"(min-width: 1024px)","href":"\u002Fimage-main\u002Flogo-new-desktop.png"},{"hid":"image","rel":"preload","as":"image","media":"(max-width: 1024px)","href":"\u002Fimage-main\u002Flogo-new.png"}],"script":[{"innerHTML":"{\"@context\":\"http:\u002F\u002Fschema.org\",\"@type\":\"EducationalOrganization\",\"name\":\"ostadbank\",\"description\":\"Ostadbank is one of the largest private education and training system in Iran for hiring and receiving private tutors.\",\"image\":\"https:\u002F\u002Fwww.ostadbank.com\u002Fimage\u002Flogo-login.png\",\"logo\":\"https:\u002F\u002Fwww.ostadbank.com\u002Fbuild\u002Fimages\u002Fsocial-network-logo.jpg\",\"url\":\"https:\u002F\u002Fwww.ostadbank.com\u002F\",\"telephone\":\"02191005343\",\"sameAs\":[\"https:\u002F\u002Ftwitter.com\u002Fostadbank\",\"https:\u002F\u002Fwww.linkedin.com\u002Fcompany\u002Fostadbank\",\"https:\u002F\u002Fwww.instagram.com\u002Fostadbank_official\u002F\",\"https:\u002F\u002Fwww.aparat.com\u002FOstadbank\u002F%D8%A7%D8%B3%D8%AA%D8%A7%D8%AF%D8%A8%D8%A7%D9%86%DA%A9\"],\"address\":{\"@type\":\"PostalAddress\",\"streetAddress\":\"تهرانپارس شرقی، خیابان جشنواره، نبش خیابان محمدی،پلاک 92، بالای فروشگاه ویوان، زنگ سوم\",\"addressLocality\":\"tehran\",\"postalCode\":\"1654868765\",\"addressCountry\":\"iran\",\"contactPoint\":[{\"@type\":\"ContactPoint\",\"contactType\":\"customer service\",\"email\":\"contact@ostadbank.com\",\"telephone\":\"02191005343\",\"url\":\"https:\u002F\u002Fwww.ostadbank.com\"}]}}","type":"application\u002Fld+json"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_6ee0d2b0 === 'function') {
    await nuxt_plugin_sentryserver_6ee0d2b0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_62d62520 === 'function') {
    await nuxt_plugin_sentryclient_62d62520(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtizitoastplugin6b8174d6_50fee7c0 === 'function') {
    await nuxt_plugin_nuxtizitoastplugin6b8174d6_50fee7c0(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_1fd4528c === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_1fd4528c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0e760a38 === 'function') {
    await nuxt_plugin_axios_0e760a38(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_377bd052 === 'function') {
    await nuxt_plugin_pluginutils_377bd052(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_dbc7e93c === 'function') {
    await nuxt_plugin_pluginrouting_dbc7e93c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_798d6b4d === 'function') {
    await nuxt_plugin_pluginmain_798d6b4d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_5d424700 === 'function') {
    await nuxt_plugin_workbox_5d424700(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_9136e3da === 'function') {
    await nuxt_plugin_metaplugin_9136e3da(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_87e798f2 === 'function') {
    await nuxt_plugin_iconplugin_87e798f2(app.context, inject)
  }

  if (typeof nuxt_plugin_lazySizes_0d8f1b5c === 'function') {
    await nuxt_plugin_lazySizes_0d8f1b5c(app.context, inject)
  }

  if (typeof nuxt_plugin_routes_3e5c7b80 === 'function') {
    await nuxt_plugin_routes_3e5c7b80(app.context, inject)
  }

  if (typeof nuxt_plugin_loadstore_3c99cd30 === 'function') {
    await nuxt_plugin_loadstore_3c99cd30(app.context, inject)
  }

  if (typeof nuxt_plugin_logger_630bf334 === 'function') {
    await nuxt_plugin_logger_630bf334(app.context, inject)
  }

  if (typeof nuxt_plugin_api_eb49b6c8 === 'function') {
    await nuxt_plugin_api_eb49b6c8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_469b2f02 === 'function') {
    await nuxt_plugin_axios_469b2f02(app.context, inject)
  }

  if (typeof nuxt_plugin_multiselect_628eaff4 === 'function') {
    await nuxt_plugin_multiselect_628eaff4(app.context, inject)
  }

  if (typeof nuxt_plugin_gtag_03b3abc0 === 'function') {
    await nuxt_plugin_gtag_03b3abc0(app.context, inject)
  }

  if (typeof nuxt_plugin_savelatestroute_165ae8e8 === 'function') {
    await nuxt_plugin_savelatestroute_165ae8e8(app.context, inject)
  }

  if (typeof nuxt_plugin_globaldirectives_4a6f1926 === 'function') {
    await nuxt_plugin_globaldirectives_4a6f1926(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueshortkey_3b659fc9 === 'function') {
    await nuxt_plugin_vueshortkey_3b659fc9(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_54a1811b === 'function') {
    await nuxt_plugin_globalcomponents_54a1811b(app.context, inject)
  }

  if (typeof nuxt_plugin_vueawesomeswiper_c02e0a2c === 'function') {
    await nuxt_plugin_vueawesomeswiper_c02e0a2c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_leafletclient_48531b77 === 'function') {
    await nuxt_plugin_leafletclient_48531b77(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_e03c7c68 === 'function') {
    await nuxt_plugin_auth_e03c7c68(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_78fc5baa === 'function') {
    await nuxt_plugin_auth_78fc5baa(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
